"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProductType = exports.CohortOfferCalloutType = exports.ClassOfService = void 0;
var ProductType;
(function (ProductType) {
    ProductType["Unspecified"] = "PRODUCT_TYPE_UNSPECIFIED";
    ProductType["Cardless"] = "CARDLESS";
    ProductType["Partner"] = "PARTNER";
})(ProductType || (exports.ProductType = ProductType = {}));
var CohortOfferCalloutType;
(function (CohortOfferCalloutType) {
    CohortOfferCalloutType["OFFER_CALLOUT_TYPE_UNSPECIFIED"] = "OFFER_CALLOUT_TYPE_UNSPECIFIED";
    /** For any earning rates related to the offer */
    CohortOfferCalloutType["REWARDS"] = "REWARDS";
    /** For any points-related signup bonus */
    CohortOfferCalloutType["REWARDS_BONUS"] = "REWARDS_BONUS";
    /** For any statement credit associated with the offer */
    CohortOfferCalloutType["STATEMENT_CREDIT"] = "STATEMENT_CREDIT";
    /** For any annual fee */
    CohortOfferCalloutType["FEE"] = "FEE";
})(CohortOfferCalloutType || (exports.CohortOfferCalloutType = CohortOfferCalloutType = {}));
var ClassOfService;
(function (ClassOfService) {
    ClassOfService["CLASS_OF_SERVICE_UNSPECIFIED"] = "CLASS_OF_SERVICE_UNSPECIFIED";
    ClassOfService["STANDARD"] = "STANDARD";
    ClassOfService["PREMIUM"] = "PREMIUM";
    ClassOfService["ULTIMATE"] = "ULTIMATE";
})(ClassOfService || (exports.ClassOfService = ClassOfService = {}));
